let BlogContent={};

$(document).ready(function () {
    $.post(https + "BlogView",function (data) {
        BlogContent=data;
    });
});
modalService=function (elm,content,modalElm){
    const data=content[elm.dataset.id];
    $(modalElm).attr({
        "data-active":elm.dataset.id
    })
    $(modalElm+" .js-title").text(data.title);
    $(modalElm+" .js-description").html(data.description.split('\n').join("<br/>"));
    $(modalElm+" .js-imgModal").css({
        "background-image":'url("'+data.imgModal+'")'
    })
    const modal = M.Modal.getInstance($(modalElm)[0]);
    modal.options.onCloseEnd=function(){
        $(modalElm+" .js-title").text('');
        $(modalElm+" .js-description").text('');
        $(modalElm+" .js-imgModal").css({
            "background-image":'url("")'
        });
    }

    modal.open();
}

$('.sectionBlogHome .element').click(function () {
    modalService(this,BlogContent,'#modalBlog');

});
